import DashboardFeature from 'features/Dashboard/index.web';

const Dashboard = ({ dimensions, sidebarOpen, search, definedWidgetData, accessLevel }) => (
  <div className="d-flex flex-column customScrollbar-X customScrollbar-Y">
    <DashboardFeature
      dimensions={dimensions}
      sidebarOpen={sidebarOpen}
      search={search}
      definedWidgetData={definedWidgetData}
      accessLevel={accessLevel}
    />
  </div>
);

export default Dashboard;
